export interface IProjectTransactionHistory {
  id: number;
  transactionId:number;
  action:string;
  state:string;
  data: { [x in string]:string};
  createdAt:string;
}
